// About section on the Home page: explains what the tool does and what it covers.

import { useTranslation } from "react-i18next";
import Section from "./Section";
import { advisoryTopics } from "../../mock/homeData";

function AboutSection() {
  const { t } = useTranslation();

  return (
    <Section
      id="about"
      eyebrow={t("home.about.eyebrow")}
      title={t("home.about.title")}
      subtitle={t("home.about.subtitle")}
      variant="muted"
    >
      <div className="homeGrid">
        <div className="homeCard" style={{ gridColumn: "span 12" }}>
          <h3 className="homeCard__title">{t("home.about.card1.title")}</h3>
          <p className="homeCard__text">{t("home.about.card1.text")}</p>
          <ul className="homeList">
            {advisoryTopics.map((key) => (
              <li key={key}>{t(key)}</li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}

export default AboutSection;
